var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFeedArticleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#feed-article-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23 19.167A3.845 3.845 0 0 1 19.167 23H3.833A3.845 3.845 0 0 1 0 19.167V3.833A3.845 3.845 0 0 1 3.833 0h15.334A3.845 3.845 0 0 1 23 3.833v15.334Z",
  fill: "#FF0082"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.167 4.792H3.833v1.916h15.334V4.791ZM19.167 8.625H3.833v1.917h15.334V8.625ZM19.167 12.458H3.833v1.917h15.334v-1.917ZM13.417 16.291H3.833v1.917h9.584v-1.916Z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "feed-article-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h23v23H0z"
})))));
export default SvgFeedArticleIcon;